import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { useMemo } from 'react'

import { Token } from '@/domain/types/Token'
import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { TokenCell } from '@/ui/molecules/data-table/components/TokenCell'
import { DataTable, DataTableColumnDefinitions } from '@/ui/molecules/data-table/DataTable'
import { ViewContractMoreDropdown } from '@/ui/molecules/view-contract-more-dropdown/ViewContractMoreDropdown'

export interface TokensToDepositRow {
  token: Token
  balance: NormalizedNumber
  blockExplorerLink: string
  openStakeDialog: () => void
}

export function TokensToDepositPanel({ token, balance, blockExplorerLink, openStakeDialog }: TokensToDepositRow) {
  const rows: TokensToDepositRow[] = [{ token, balance, blockExplorerLink, openStakeDialog }]

  const columnDef: DataTableColumnDefinitions<TokensToDepositRow> = useMemo(
    () => ({
      token: {
        header: 'Token',
        renderCell: ({ token }) => <TokenCell token={token} />,
      },
      balance: {
        header: 'Balance',
        headerAlign: 'right',
        renderCell: ({ balance, token }) => (
          <div className="typography-label-2 flex w-full flex-row justify-end">
            {balance.eq(0) ? '-' : token.format(balance, { style: 'auto' })}
          </div>
        ),
      },
      actions: {
        header: '',
        renderCell: ({ balance, blockExplorerLink, openStakeDialog }) => {
          return (
            <div className="flex justify-end gap-1 sm:gap-3">
              <Button variant="secondary" size="s" disabled={balance.eq(0)} onClick={openStakeDialog}>
                Deposit
              </Button>
              <ViewContractMoreDropdown blockExplorerLink={blockExplorerLink} />
            </div>
          )
        },
      },
    }),
    [],
  )

  return (
    <Panel spacing="none">
      <div className="flex flex-col gap-6 p-4 pb-0 md:px-8 md:py-6 md:pb-0">
        <h3 className="typography-heading-4 text-primary">Tokens to deposit</h3>
        <DataTable
          gridTemplateColumnsClassName="grid-cols-[repeat(2,1fr)_120px] sm:grid-cols-[repeat(2,1fr)_140px]"
          data={rows}
          columnDef={columnDef}
        />
      </div>
    </Panel>
  )
}
